import { apiUrl } from './apiBase';
import {
  getAdminApiToken,
  setAuthErrorMessage,
  useAdminApiAuth,
} from './adminApiAuth';

const AUTH_ERROR_TEXT =
  'Ustaw lub zaktualizuj token panelu administracyjnego w ustawieniach i spróbuj ponownie.';

const SERVICE_UNAVAILABLE_TEXT =
  'API jest chwilowo niedostępne (503). Token jest zapisany — odczekaj chwilę i spróbuj ponownie.';

const mergeHeaders = (baseHeaders = {}, token = '') => {
  if (!token) {
    return baseHeaders;
  }

  const merged = new Headers(baseHeaders instanceof Headers ? baseHeaders : baseHeaders || {});
  merged.set('Authorization', `Bearer ${token}`);
  merged.set('X-Admin-Token', token);
  return merged;
};

const normalizeUrl = (input) => {
  if (typeof input !== 'string') {
    return input;
  }

  // Keep admin routes on current origin (admin.muala.app),
  // do not rewrite them to API origin.
  if (input.startsWith('/admin/')) {
    return input;
  }

  const isAbsolute = /^https?:\/\//i.test(input) || input.startsWith('//');
  return isAbsolute ? input : apiUrl(input);
};

const shouldFlagAuthError = (status) => status === 401 || status === 403;

export const apiFetch = async (input, init = {}, options = {}) => {
  const { skipAuth = false } = options;
  const url = normalizeUrl(input);
  const startedAt = Date.now();

  const requestInit = { ...init };
  if (!skipAuth) {
    const token = getAdminApiToken();
    requestInit.headers = mergeHeaders(requestInit.headers, token);
  }

  const method = (requestInit.method || 'GET').toUpperCase();
  console.debug('[apiFetch:start]', {
    method,
    url,
    skipAuth,
  });

  const response = await fetch(url, requestInit);
  const elapsedMs = Date.now() - startedAt;

  console.debug('[apiFetch:end]', {
    method,
    url,
    status: response.status,
    ok: response.ok,
    elapsedMs,
  });

  if (shouldFlagAuthError(response.status)) {
    setAuthErrorMessage(AUTH_ERROR_TEXT);
  } else if (response.status === 503) {
    setAuthErrorMessage(SERVICE_UNAVAILABLE_TEXT);
  }

  return response;
};

export const useApiAuthState = () => {
  return useAdminApiAuth();
};


